import {
    ColumnType,
    FilterType,
    YASC_CRUD_ALL_MODES_V3,
    yascClassDefaultSectionModes,
    yascClassDefaultSorting,
    yascClassDescription,
    yascClassDisplayName,
    yascClassFormSectionTitle,
    yascDisplayName,
    yascEmail,
    yascEntityName,
    yascField,
    yascFilterConfig,
    yascFormGrid,
    yascFormIgnore,
    yascFormKind,
    yascMaxLength,
    yascOptionsKey,
    yascPhone,
    yascRequired,
    yascTableColumn,
    yascTableFilterType,
    yascTableIgnore,
    yascTableIndex,
    yascTableWidth,
} from '@yasc/yasc-material-components';
import {Salutation} from '../../../enums';

@yascClassDefaultSorting([{fieldName: 'lastName', direction: 'asc', sortIndex: 0}, {fieldName: 'firstName', direction: 'asc', sortIndex: 1}])
@yascEntityName('general_contact')
@yascClassDisplayName('general_contact')
@yascClassFormSectionTitle('crm_contact_basicInfo_tabLabel')
@yascClassDescription('crm_contact_basicInfo_description')
@yascClassDefaultSectionModes(YASC_CRUD_ALL_MODES_V3)
export class ContactPerson {
    @yascField()
    @yascTableIgnore(true)
    @yascFormIgnore()
    id = 0;

    @yascField()
    @yascDisplayName('general_salutation')
    @yascTableIndex(0)
    @yascTableColumn(ColumnType.Select)
    @yascFormKind('select')
    @yascOptionsKey('contactSalutations')
    @yascFormGrid({row: 1, width: 1})
    salutation: Salutation = Salutation.employeeSalutationsOther;

    @yascField()
    @yascDisplayName('general_title')
    @yascTableIgnore(true)
    @yascMaxLength(10)
    @yascFormGrid({row: 1, width: 1})
    title = '';

    @yascField()
    @yascDisplayName('general_firstName')
    @yascTableIndex(1)
    @yascTableWidth(2)
    @yascTableFilterType(FilterType.text)
    @yascRequired()
    @yascMaxLength(100)
    @yascFormGrid({row: 2, width: 1})
    firstName = '';

    @yascField()
    @yascDisplayName('general_lastName')
    @yascTableIndex(2)
    @yascTableWidth(2)
    @yascTableFilterType(FilterType.text)
    @yascRequired()
    @yascMaxLength(100)
    @yascFormGrid({row: 2, width: 1})
    lastName = '';

    @yascField()
    @yascDisplayName('general_company')
    @yascTableIndex(3)
    @yascTableWidth(2)
    @yascTableFilterType(FilterType.select)
    @yascOptionsKey('contactCompanies')
    @yascFilterConfig({
        getGroup: () => [],
        multiselect: true,
    })
    @yascFormIgnore()
    companyName = '';

    @yascField()
    @yascDisplayName('general_company')
    @yascTableIgnore(true)
    @yascFormKind('autocomplete')
    @yascOptionsKey('contactCompanies')
    @yascRequired()
    @yascFormGrid({row: 3, width: 2, fullRow: true})
    companyId: number | null = null;

    @yascField()
    @yascDisplayName('general_department')
    @yascTableIndex(4)
    @yascTableFilterType(FilterType.text)
    @yascMaxLength(150)
    @yascFormGrid({row: 4, width: 2, fullRow: true})
    department = '';

    @yascField()
    @yascDisplayName('general_email')
    @yascTableIndex(5)
    @yascTableWidth(2)
    @yascTableFilterType(FilterType.text)
    @yascEmail()
    @yascMaxLength(70)
    @yascFormGrid({row: 5, width: 2, fullRow: true})
    email = '';

    @yascField()
    @yascDisplayName('general_phone')
    @yascTableIndex(6)
    @yascTableFilterType(FilterType.text)
    @yascPhone()
    @yascMaxLength(30)
    @yascFormGrid({row: 6, width: 1})
    phone = '';

    @yascField()
    @yascDisplayName('general_mobile')
    @yascTableIndex(7)
    @yascPhone()
    @yascMaxLength(30)
    @yascFormGrid({row: 6, width: 1})
    mobile = '';

    constructor(init: Partial<ContactPerson> = {}) {
        Object.assign(this, init);
    }
}
